// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { LearningUnit_abstract } from './../abstract/SagaBase/LearningUnit_abstract';
export class LearningUnit extends LearningUnit_abstract {}
